export default __webpack_public_path__ + "static/media/downloadIconHCSelected.c687cd51.svg";